import React, { useEffect, useState } from 'react';
import * as RO from './Javascript/ReportObjects';
import * as G from './Javascript/General';
import { convertCoordinates, waypoints_only} from './Javascript/CustomiseReport';
import './CSS/style.css';

interface Props {
  positionTimeline: RO.PositionAreaTimeline[];
}
const change_coord_format = (value: string) => {
    convertCoordinates(value);
};

const TimelineTable: React.FC<Props> = ({ positionTimeline}) => {
    const [positionData, setPositionData] = useState<RO.PositionAreaTimeline[] | null>(positionTimeline);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setPositionData(positionData);
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, [positionTimeline])

    return (
    <>
        {positionData == null ? (
            <p>Error occurred: Timeline table failed</p>
        ) : (
        <div className="report_row timeline_report_table">
            <div className="inner_padding">

                <p className="sub_title">Timeline</p>

                <table key="timeline_table" className="detailed_class">
                    <thead>
                        <tr>
                            <th style={{ width: '10%'}}>Date</th>
                            <th style={{ width: '20%'}}>Ocean</th>
                            <th style={{ width: '20%'}}>Country</th>
                            <th style={{ width: '12%'}}>Port</th>
                            <th style={{ width: '5%'}}>% Load</th>
                            <th style={{ width: '15%'}}>Commodity</th>
                            <th style={{ width: '10%'}}>Dest.</th>
                            <th style={{ width: '10%'}}>ETA</th>
                        </tr>
                    </thead>
                    <tbody>
                    {positionData && positionData.map((item: any, index) => (
                        <tr key={"timeline_table" + index}>
                            <td>{ G.displayValue(item?.position.date_received.toISOString().replace("T", " ").split(':').slice(0, 2).join(':')) }</td>
                            <td>{ G.displayValue(item?.spacial_area?.sea_zone) }</td>
                            <td>{ G.displayValue(item?.spacial_area?.eez) }</td>
                            <td>{ G.displayValue(item?.spacial_area?.port_name) }</td>
                            <td>{ G.displayValue(item?.position.load) }</td>
                            <td>{ G.displayValue(item?.position.commodity) }</td>
                            <td>{ G.displayValue(item?.position.destination) }</td>
                            <td>{`${String(item?.position.eta_month).padStart(2, '0')}-${String(item?.position.eta_day).padStart(2, '0')} ${String(item?.position.eta_hour).padStart(2, '0')}:${String(item?.position.eta_minute).padStart(2, '0')}`}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
        )}
    </>
    );
};
export default TimelineTable;